import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as _function from '../function'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: _function.RESOURCE.payload.dimension.partialId,
      partialId: _function.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'Whether this space function is required when matching payroll to space usage.',
    isOptional: false,
    name: 'Is Required for Matching Payroll?',
    partialId: PartialId.Standard.create('is_required_for_matching_payroll'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
